// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"175":"ecf873a8856e024160d9","231":"7569fd4e9c1710ee8bef","401":"8088497398a830803d88","678":"d6df970a7f9468843b68","883":"bcf5c3c2199d3e66aff2"}[chunkId] + ".js";
};